export enum ComponentNames {
  nouOrgan = 'modals/ModalNouOrgan',
  editOrgan = 'modals/ModalEditOrgan',
  deleteOrgan = 'modals/ModalEsborrarAction'
}
